// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Layers = require("@deck.gl/layers");

function make(exteriorRing, interiorRings) {
  return [exteriorRing].concat(interiorRings);
}

function bounds(polygons) {
  let coordinates = polygons.flatMap(polygon => polygon.flatMap(ring => ring));
  let first = coordinates[0];
  if (first !== undefined) {
    return Stdlib_Array.reduce(coordinates, {
      north: first.lat,
      east: first.lng,
      south: first.lat,
      west: first.lng
    }, (bounds, coordinate) => ({
      north: Math.max(bounds.north, coordinate.lat),
      east: Math.max(bounds.east, coordinate.lng),
      south: Math.min(bounds.south, coordinate.lat),
      west: Math.min(bounds.west, coordinate.lng)
    }));
  }
}

function makeLayer(id, polygons, fillColor, lineColor, lineWidth) {
  return new Layers.PolygonLayer({
    id: id,
    data: polygons,
    pickable: false,
    filled: true,
    stroked: true,
    lineWidthUnits: "pixels",
    getPolygon: polygon => polygon.map(ring => ring.map(coordinates => [
      coordinates.lng,
      coordinates.lat
    ])),
    getFillColor: param => fillColor,
    getLineColor: param => lineColor,
    getLineWidth: param => lineWidth
  });
}

exports.make = make;
exports.bounds = bounds;
exports.makeLayer = makeLayer;
/* @deck.gl/layers Not a pure module */
